import { IconCalendar } from "@tabler/icons-react";
import "./ClientConsult.scss";
import { Text, Button, Tooltip } from "@mantine/core";
import { openNewTab } from "@/utils/browserUtils";

interface ClientConsultProps {
  consultLink: string;
}

const ClientConsult = ({ consultLink }: ClientConsultProps) => {
  const handleOpenConsultLink = () => {
    openNewTab(consultLink);
  };

  return (
    <div className="panel-container client-consult">
      <div className="panel-header">
        <IconCalendar size={20} />
        <p>Schedule a Consult</p>
      </div>

      <div className="panel-body">
        <Text color="dimmed">
          Discuss your tax situation, financial goals, or explore personalized
          strategies
        </Text>
        <Tooltip
          label="Your taxpro has not configured a consult link"
          disabled={!!consultLink}
          withArrow
        >
          <Button
            onClick={handleOpenConsultLink}
            disabled={!consultLink}
            size="lg"
          >
            Schedule a call
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

export default ClientConsult;
